import { AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';

import { ContextDialog, Link, LinkVariant, RemoveIcon, Tooltip } from '@dreryk/react-components';

import {
   VisitCancelNotConfirmedModalOpener,
   VisitCancelShowModalEventInterceptor,
} from '~libs.desktop.shared.visit-cancel';

import { appointmentsTranslationKeys, calendarTranslationKeys } from '../../../../../translations';

import { StyledAppointmentDetailsCancelButton } from './AppointmentDetailsCancelButton.styled';

type AppointmentDetailsCancelButtonProps = {
   readonly appointmentId: number;
   readonly appointmentStatus: AppointmentStatus;
   readonly onAppointmentCancelled: VoidFunction;
   readonly timeSlotConfirmed: boolean;
};

export const AppointmentDetailsCancelButton = (props: AppointmentDetailsCancelButtonProps): JSX.Element => {
   const visitNotStarted = props.appointmentStatus === 'REGISTERED';
   const tooltipMessage = visitNotStarted ? undefined : appointmentsTranslationKeys.cancellingIsNotPossible;

   return (
      <ContextDialog.FooterElement>
         <>
            {props.timeSlotConfirmed ? null : (
               <VisitCancelNotConfirmedModalOpener
                  appointmentId={props.appointmentId}
                  onSuccess={props.onAppointmentCancelled}
               >
                  {({ openModal }) => (
                     <StyledAppointmentDetailsCancelButton>
                        <Tooltip testId={'contextDialogCancel'} content={tooltipMessage} disabled={!tooltipMessage}>
                           <Link
                              testId={'cancel'}
                              label={calendarTranslationKeys.cancel}
                              icon={<RemoveIcon />}
                              variant={LinkVariant.ERROR}
                              disabled={!visitNotStarted}
                              onClick={openModal}
                           />
                        </Tooltip>
                     </StyledAppointmentDetailsCancelButton>
                  )}
               </VisitCancelNotConfirmedModalOpener>
            )}
            {props.timeSlotConfirmed ? (
               <VisitCancelShowModalEventInterceptor
                  appointmentId={props.appointmentId}
                  cancellable={visitNotStarted}
                  onSuccess={props.onAppointmentCancelled}
                  onFault={props.onAppointmentCancelled}
               >
                  <StyledAppointmentDetailsCancelButton>
                     <Tooltip testId={'contextDialogCancel'} content={tooltipMessage} disabled={!tooltipMessage}>
                        <Link
                           testId={'cancel'}
                           label={calendarTranslationKeys.cancel}
                           icon={<RemoveIcon />}
                           variant={LinkVariant.ERROR}
                           disabled={!visitNotStarted}
                        />
                     </Tooltip>
                  </StyledAppointmentDetailsCancelButton>
               </VisitCancelShowModalEventInterceptor>
            ) : null}
         </>
      </ContextDialog.FooterElement>
   );
};
